import { formatInTimeZone } from "date-fns-tz";
import { EM_DASH } from "constants/schedule-monitor.constants";
import { DEFAULT_DATE_FORMAT_WITH_TIMEZONE, DEFAULT_DISPLAY_TIMEZONE } from "constants/time.constants";


export const resolveDisplayTimezone = (): string => DEFAULT_DISPLAY_TIMEZONE;

export const resolveDisplayTimezoneAbbreviation = (): string =>
    formatInTimeZone(new Date(), resolveDisplayTimezone(), "zzz");

export const formatInDisplayTimezone = (
    date: Date | null, formatPattern: string = DEFAULT_DATE_FORMAT_WITH_TIMEZONE,
): string => {
    if (!date || Number.isNaN(date.getTime())) {
        return EM_DASH;
    }
    try {
        return formatInTimeZone(date, resolveDisplayTimezone(), formatPattern);
    } catch {
        return EM_DASH;
    }
};

export default formatInDisplayTimezone;
